<div class="form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <app-mat-form-field>
          <input appMatInput type="text" formControlName="formSource" placeholder="Source" cdkFocusInitial />
        </app-mat-form-field>
      </div>

      <div class="col-md-6">
        <app-mat-form-field>
          <input appMatInput type="text" formControlName="formQuerystring" placeholder="Querystring" cdkFocusInitial />
        </app-mat-form-field>
      </div>

      <div class="col-md-6">
        <app-mat-form-field>
          <input appMatInput type="text" formControlName="formPath" placeholder="Path" cdkFocusInitial />
        </app-mat-form-field>
      </div>

      <div class="col-md-6">
        <app-mat-form-field>
          <input appMatInput type="text" formControlName="formDataType" placeholder="Data Type" cdkFocusInitial />
        </app-mat-form-field>
      </div>

      <div class="col-md-6">
        <button app-mat-stroked-button (click)="resubscribe()">Resubscribe</button>
      </div>
    </div>
  </form>
</div>
